// extracted by mini-css-extract-plugin
export default {"list":"_-_-record-it-components-src-misc-MessageListBox-__list"};